import React, { useState } from 'react'
import useDashboardApi from '../../hooks/useDashboardApi'
import { LoadingComponent, EmptyResult } from 'usbc-web-react-library'
import { useAuth } from "react-oidc-context";
import { PhMenuCard } from 'usbc-web-react-partnerhub-library'

function SelectHub() {
    const [partnersList, setPartnersList] = useState(null);
    const [searchKey, setSearchKey] = useState(null);

    const auth = useAuth();

    const {
        getPartners,
        response: partners,
        loading: partnersLoading,
    } = useDashboardApi();

    React.useEffect(() => {
        getPartners().then(result => {
            setPartnersList(result);
        });
    }, []);

    function searchKeyChange(event) {
        setSearchKey(event.target.value);
        let filteredPartners = partners.filter(x => x.name.toLowerCase().includes(event.target.value.toLowerCase()));
        setPartnersList(filteredPartners);
    }

    return (
        <div className='custom-card'>
            <LoadingComponent isLoading={() => partnersLoading === true} description={"Loading Partners"}>
                {
                    (partners != null && partners.length > 0) ?
                        <>
                            <div className="row g-1 gy-3 pt-0 select-hub">
                                <figure className="text-center">
                                    <h4 className="text-secondary"
                                        style={{ fontFamily: "'Oswald', sans-serif", textTransform: "uppercase", fontWeight: "600", color: "#63666A", fontStyle: "italic" }}>
                                        Choose a Partner Hub
                                    </h4>
                                </figure>
                                <div className="row gx-1 gy-3 mt-0">
                                    <div className='col-lg-12' style={{ paddingLeft: "13px", paddingRight: "13px" }}>
                                        <div className="form-floating mb-3">
                                            {searchKey &&
                                                <span className="position-absolute top-10 start-0 translate-middle badge rounded-pill bg-usbc-blue">
                                                    {partnersList?.length || 0}
                                                    <span className="visually-hidden"></span>
                                                </span>
                                            }
                                            <input type="text" className="form-control" id="searchKey" name="searchKey" placeholder="Search by name" onChange={searchKeyChange} />
                                            <label htmlFor="searchKey">Search by name</label>
                                        </div>
                                    </div>
                                    {partnersList.map((partner, key) => {
                                        let link = {
                                            applicationId: 2, // Setting app icon
                                            displayName: partner.name,
                                            description: partner.relationship + ' Partner Hub',
                                            actionText: 'Manage ' + partner.name,
                                            onClick: () =>
                                                auth.signinRedirect({
                                                    extraQueryParams: { auth_type: 'group', groupid: partner.id }
                                                }),
                                        };
                                        return <PhMenuCard key={key} link={link} />;
                                    }
                                    )}
                                </div>

                            </div>
                        </>
                        :
                        <EmptyResult>No Partners Results!</EmptyResult>
                }
            </LoadingComponent>
        </div>
    )
}

export default SelectHub